import CandidateListCard from './CandidateListCard.component';

export default CandidateListCard;
